export enum GameState {
    INTRODUCTION,
    MAIN,
    WIN,
    LOOSE,
};